<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
  export default {
    data: () => ({
        drawer: null,
    })
  }
</script>
